import React from "react";
import ViewLeadComponent from "../../components/lead-components/leads-view-component";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../layout";
import LeadsActivityList from "../../components/lead-components/leads-activity/leads-activity-list";
import LeadCommentsList from "../../components/lead-components/leads-comments/lead-comments-list";
import LeadFileCommentsLits from "../../components/lead-components/leads-comments/lead-file-comments-lits";
import { useRole } from "../../context/role/RoleContext";

const ViewLead = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { state } = useRole();
  const permission = state?.role?.lead_activity;
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("activeTab");

  return (
    <MainLayout>
      <section className="flex flex-col h-full">
        <div className="my-4 bg-lightBg px-3 py-1 flex justify-between items-center">
          <div className="flex overflow-auto gap-4 items-center">
            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "lead" ? "bg-primary " : "bg-lightText"}
          `}
              onClick={() => navigate(`/lead/view/${id}?activeTab=lead`)}
            >
              Lead
            </button>
            {(permission?.read || permission?.write) && (
              <button
                className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "activity" ? "bg-primary" : "bg-lightText"}
          `}
                onClick={() => navigate(`/lead/view/${id}?activeTab=activity`)}
              >
                Activity
              </button>
            )}
            <button
              className={` px-5 py-1 rounded-lg text-white
          ${activeTab === "comments" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() => navigate(`/lead/view/${id}?activeTab=comments`)}
            >
              Comments
            </button>
            <button
              className={` px-5 py-1 rounded-lg text-white text-nowrap
          ${activeTab === "filecomments" ? "bg-primary" : "bg-lightText"}
          `}
              onClick={() =>
                navigate(`/lead/view/${id}?activeTab=filecomments`)
              }
            >
              File Comments
            </button>
          </div>
        </div>

        {activeTab === "lead" && <ViewLeadComponent />}
        {activeTab === "activity" &&
          (permission?.read || permission?.write) && (
            <LeadsActivityList activeTab={activeTab} />
          )}
        {activeTab === "comments" && <LeadCommentsList />}
        {activeTab === "filecomments" && <LeadFileCommentsLits />}
      </section>
    </MainLayout>
  );
};

export default ViewLead;
